import { useMutation } from '@tanstack/react-query';
import { useTranslations } from 'next-intl';
import { authApi } from './auth.api';

export function useLoginMutation() {
  return useMutation({
    mutationFn: authApi.login,
    meta: { skipGlobalSuccessToast: true, skipGlobalErrorToast: true }
  });
}

export function useVerifyLoginOtpMutation() {
  return useMutation({
    mutationFn: authApi.verifyLoginOtp,
    meta: { skipGlobalSuccessToast: true, skipGlobalErrorToast: true }
  });
}

export function useForgotPasswordMutation() {
  return useMutation({
    mutationFn: authApi.forgotPassword,
    meta: { skipGlobalErrorToast: true }
  });
}

export function useResetPasswordMutation() {
  const t = useTranslations('auth.resetPassword');

  return useMutation({
    mutationFn: authApi.resetPassword,
    meta: { fallbackSuccessMessage: t('success') }
  });
}
